'use strict';

const filter = require('lodash.filter');
const forEach = require('lodash.foreach');
const repeat = require('lodash.repeat');

const math = require('mathjs');

module.exports = {

  getNewValueId: function(exercise, properties) {
    return properties.leg + '-' + properties.group +
      '-' + properties.element + '-' + properties.position + '-' + properties.index
  },

  valueTypeFormat: function(valueType) {
    let format = '0';
    if (valueType.precision > 0) {
      const precision = math.ceil(valueType.precision);
      format += '.' + repeat('0', precision);
    }
    return format;
  },

  equalProperties: function(p1, p2) {
    if (! (p1.position === p2.position && p1.index === p2.index && p1.leg === p2.leg)) {
      return false;
    }

    return (
      p1.group === p2.group && p1.element === p2.element
    );
  },

  exerciseGetValue: function(exercise, properties) {
    const values = filter(exercise.scoreValues, value => this.equalProperties(value, properties))

    if (values.length) {
      return values[0]
    }
    return undefined
  },

  extractCsvScores: function(exercise) {
    let scores = {};

    forEach(exercise.scoreValues, value => {
      let pass = scores[value.leg];
      if (! pass) {
        pass = {};
      }
      let group = pass[value.group.replace('.', '_')];
      if (! group) {
        group = {};
      }

      let element = group[value.element.replace('.', '_')];
      if (! element) {
        element = {};
      }

      let position = element[value.position];
      if (! position) {
        position = {};
      }

      let publicValue = value.publicValue
      if (publicValue < 0) {
        publicValue = null
      }

      position[value.index] = publicValue
      element[value.position] = position
      group[value.element.replace('.', '_')] = element
      pass[value.group.replace('.', '_')] = group
      scores[value.leg] = pass
    })
    return scores
  },
};
